import { styled } from "@mui/material/styles";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import SideNavApps from "./SideNavApps";
import SideNavLogin from "./SideNavLogin";
const SvgImage = styled("div")(({ path, imagecolor }) => ({
    backgroundColor: imagecolor,
    WebkitMask: "url(" + path + ") no-repeat center / contain",
    filter: "none !important", // overwrite css style
}));
const SideNavItem = styled("div")(({ color, hoverColor }) => ({
    "&:hover": {
        backgroundColor: hoverColor,
        "& > div": {
            backgroundColor: color,
        },
    },
}));
export const SideNav = observer((props) => {
    const [hasError, setError] = useState(false);
    const [authInfo, setAuthInfo] = useState(props.appModel.authInfo);
    const pathToStatic = props.appModel.pathToStatic;
    const i18n = props.appModel.i18n.bind(props.appModel);
    let open = props.appModel.appState.sideNavOpen;
    useEffect(() => {
        let authSubscription = props.appModel.subscribeToAuthChanged((newAuthInfo) => {
            setAuthInfo(newAuthInfo);
        });
        return () => {
            authSubscription.unsubscribe();
        };
    }, []);
    /*componentDidCatch(error, info) {
      this.setState({ hasError: true });
      console.error(
        "Error during rendering in SideNav: %o\nInfo: %o",
        error,
        info
      );
    }*/
    const toggleSideNav = (event) => {
        let currentOpen = props.appModel.appState.sideNavOpen;
        props.appModel.appState.setSideNavOpen(!currentOpen);
    };
    const renderSideNavToggle = () => {
        let imageSrc;
        if (open) {
            imageSrc = pathToStatic + "images/icon_sidenavtoggle-open.svg";
        }
        else {
            imageSrc = pathToStatic + "images/icon_sidenavtoggle.svg";
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(SideNavItem, { id: "sideNavToggle", className: "side-nav__item side-nav__toggle", onClick: toggleSideNav, hoverColor: props.appModel.theme.primaryColor, color: "#FFFFFF" },
                React.createElement(SvgImage, { path: imageSrc, className: "side-nav__item--icon", imagecolor: props.appModel.theme.primaryColor }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("nav", { className: open ? "side-nav side-nav--is-opened" : "side-nav", id: "sideNav" },
            renderSideNavToggle(),
            React.createElement("div", { className: "side-nav__menu" },
                !props.appModel.custom.omitDshIntegration && (React.createElement(SideNavApps, { appModel: props.appModel, authInfo: authInfo })),
                props.children,
                React.createElement(SideNavLogin, { appModel: props.appModel, authInfo: authInfo })))));
});
export default SideNav;
